import { supabase } from '../lib/supabase';

// ── Categories ──────────────────────────────────────────────────

export const fetchCategories = async () => {
  const { data, error } = await supabase
    .from('service_categories')
    .select('*')
    .order('sort_order', { ascending: true });
  if (error) throw error;
  return data || [];
};

export const insertCategory = async (payload) => {
  const { error } = await supabase.from('service_categories').insert([payload]);
  if (error) throw error;
};

export const updateCategory = async (id, updates) => {
  const { error } = await supabase.from('service_categories').update(updates).eq('id', id);
  if (error) throw error;
};

export const reorderCategories = async (items) => {
  await Promise.all(
    items.map((c, i) => supabase.from('service_categories').update({ sort_order: i + 1 }).eq('id', c.id))
  );
};

// ── Services ────────────────────────────────────────────────────

export const fetchServices = async () => {
  const { data, error } = await supabase
    .from('services')
    .select('*')
    .order('sort_order', { ascending: true });
  if (error) throw error;
  return data || [];
};

export const insertService = async (payload) => {
  const { error } = await supabase.from('services').insert([payload]);
  if (error) throw error;
};

export const updateService = async (id, updates) => {
  const { error } = await supabase.from('services').update(updates).eq('id', id);
  if (error) throw error;
};

export const deleteService = async (id) => {
  const { error } = await supabase.from('services').delete().eq('id', id);
  if (error) throw error;
};

export const reorderServices = async (items) => {
  await Promise.all(
    items.map((s, i) => supabase.from('services').update({ sort_order: i + 1 }).eq('id', s.id))
  );
};
